<template>
  <div class="relative w-9 h-9">
    <transition-group>
      <svg v-if="expanded" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"
      key="expanded-switcher-icon">
        <path d="M21 23.0156L18.3977 20.4133C18.1781 20.1937 17.822 20.1937 17.6023 20.4133L15 23.0156" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 12.982L18.3977 15.5843C18.1781 15.8039 17.8219 15.8039 17.6023 15.5843L15 12.982" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"
      key="collapsed-switcher-icon">
        <path d="M15 15.7494L17.6023 13.1472C17.8219 12.9275 18.1781 12.9275 18.3977 13.1472L21 15.7494M15 20.2494L17.6023 22.8517C17.8219 23.0714 18.1781 23.0714 18.3977 22.8517L21 20.2494" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'ExpandSwitcherIcon',
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.v-enter-active {
  transition: opacity 100ms ease-in-out;
}
.v-leave-active {
  transition: opacity 100ms ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>